import { Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";

import "./event.scss";

const SytledLi = styled("li")(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
}));

const Event = ({ name, content, duration, lastEvent }) => {
    return (
        <div className="event flexContainer">
            <div className="flexContainer flexCol centerAlign">
                <div className="outerDot flexContainer centerAlign">
                    <div className="innerDot"></div>
                </div>
                <div className="eventVerticalLineContainer flexGrow p-2">
                    {lastEvent ? null : (
                        <div className="eventVerticalLine fullHeight"></div>
                    )}
                </div>
            </div>
            <div className="eventContentContainer flexContainer flexGrow">
                <div className="eventContent">
                    <Typography variant="h6">
                        <a href={content.url}>{name}</a>
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        {`${content.role}`}
                    </Typography>
                    <Typography variant="overline" gutterBottom>
                        {`${duration}`}
                    </Typography>

                    {content.projects.map(({ id, name, description }) => (
                        <div key={id}>
                            <Typography variant="subtitle1" gutterBottom>
                                {`${name}`}
                            </Typography>
                            <ul key={id} className="eventDesciption">
                                {description.map((point, idx) => (
                                    <SytledLi key={idx}>{point}</SytledLi>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Event;
